module.exports = function(done, value){
  return {value: value, done: !!done};
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/$.iter-step.js
 ** module id = 497
 ** module chunks = 0
 **/